
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { TranslationProvider } from './contexts/TranslationContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { TenantViewProvider } from './contexts/TenantViewContext';
import { Toaster } from "@/components/ui/sonner";
import { Toaster as ToastToaster } from "@/components/ui/toaster";
import { ConsentBanner } from './components/ConsentBanner';
import LayoutWithSidebar from './components/Layout/LayoutWithSidebar';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';

import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TranslationProvider>
          <AuthProvider>
            <TenantViewProvider>
            <NotificationProvider>
              <BrowserRouter>
                <ErrorBoundary>
                  <Suspense fallback={
                    <div className="min-h-screen flex items-center justify-center">
                      <LoadingSpinner size="lg" />
                    </div>
                  }>
                    <LayoutWithSidebar />
                  </Suspense>
                  <ConsentBanner />
                  <Toaster />
                  <ToastToaster />
                </ErrorBoundary>
              </BrowserRouter>
            </NotificationProvider>
            </TenantViewProvider>
          </AuthProvider>
        </TranslationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
